import { filterObject, keys } from 'services/utils'
import { APIEntity, PackageEntity } from 'services/api/entities'
import {
  UserType,
  FullProductServiceName,
  LinkedProductType,
  PricingUser,
  ProductServiceDiscriminator,
  ServiceCollectionName,
  ProductServiceName,
} from 'types/common'

export const NAMES_DISCRIMINATORS_MAP: Record<
  ProductServiceDiscriminator,
  ServiceCollectionName
> = {
  VirtualConfigurator: 'virtuals',
  FoodConfigurator: 'foods',
  RentConfigurator: 'rents',
  MusicConfigurator: 'musics',
  DrinkConfigurator: 'drinks',
  PhysicalConfigurator: 'physicals',
  LocationConfigurator: 'locations',
  ProfessionalConfigurator: 'professionals',
}

export const PACKAGE_NAME_DISCRIMINATORS_MAP: Record<
  Extract<ProductServiceDiscriminator, 'DrinkConfigurator'>,
  Extract<PackageEntity, 'drinkpackages'>
> = { DrinkConfigurator: 'drinkpackages' }

export const USER_TYPES_MAP: Record<UserType, PricingUser> = {
  pmi: 'business',
  supplier: 'business',
}

export const PRODUCT_ENTITY_SERVICE_MAP: Record<LinkedProductType, APIEntity> =
  {
    drink: 'drinks',
    food: 'foods',
    foodUpselling: 'foodsupselling',
    location: 'locations',
    locationUpselling: 'locationupselling',
    logistic: 'logistics',
    music: 'musics',
    physical: 'physicals',
    physicalUpselling: 'physicalupselling',
    virtual: 'virtualupselling',
    virtualUpselling: 'virtualupselling',
    professional: 'professionals',
    rent: 'rents',
  }

export const PRODUCT_SERVICE_ENTITY_MAP: Partial<
  Record<APIEntity, LinkedProductType>
> = {
  physicals: 'physical',
  virtuals: 'virtual',
}

export const COLLECTION_NAME_SERVICE_MAP: Record<
  ServiceCollectionName,
  FullProductServiceName
> = {
  foods: 'foodService',
  locations: 'locationService',
  physicals: 'physicalService',
  virtuals: 'virtualService',
  professionals: 'professionalService',
  drinks: 'drinkService',
  musics: 'musicService',
  rents: 'rentService',
}

/**
 *  util to get name of api entity passing a services name
 * @param servName services name
 * @returns name api entity
 */
export const getNameFromServicesName = (servName: ProductServiceName) => {
  const [name] = keys(
    filterObject((val, _key) => val === servName, COLLECTION_NAME_SERVICE_MAP)
  )
  return name
}
